import play from '../assets/play.svg';
import pause from '../assets/pause.svg';
var Icons = {
    play: play,
    pause: pause
};
export default Icons;